export const container = `
  p-3 bg-base-white rounded z-10
  absolute top-12 right-0
  shadow-3sm w-fit

  min-w-64 lg:min-w-72
  max-w-[300px] lg:max-w-none
`;

export const content = `
  relative flex
`;

export const form = `flex gap-2 flex-col lg:flex-row`;

export const route = `flex flex-col gap-4`;
